import { gql } from '@apollo/client'

export const DELETE_EMAIL_TEMPLATE_MUTATION = gql`
  mutation DeleteEmailTemplate($id: ID!) {
    deleteEmailTemplate(id: $id) {
      success
      errors
    }
  }
`
